import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ProfileInfoPayload } from 'Interfaces/Profile';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: ProfileInfoPayload) =>
    $actions.user.updateProfileInfo(dispatch, payload),
  );
};
